import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 40,
        type: 'number',
        selector: false,
        textAlign: 'left',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'name',
        title: 'Name',
        width: 200,
        sortable: false,
        template: function(data) {
          const source = {
            encoder: ['label-success', 'Encoder', 'New desktop-encoder video'],
            wg_video: ['label-secondary', 'wg-video', 'Migrated from the legacy wg-video server'],
            upload: ['label-secondary', 'Upload', 'Legacy direct upload']
          }[data.source_kind] || ['label-secondary', data.source_kind, ''];

          const onR2 = data.on_r2
            ? ['label-success', 'On R2', 'Content is available on Cloudflare R2']
            : ['label-secondary', 'no R2', 'Not on R2 yet'];

          const serving = {
            r2: ['label-primary', 'via R2', 'Viewers currently get the R2 stream (global toggle)'],
            wg_video: ['label-warning', 'via wg-video', 'Viewers currently get the wg-video fallback'],
            none: ['label-danger', 'no stream', 'No playable URL for this video']
          }[data.serving] || ['label-secondary', data.serving, ''];

          const badge = (b) =>
            `<span class="label label-inline font-weight-bold ${b[0]}" style="margin-right:4px;margin-top:4px;" data-controller="tooltip" title="${b[2]}">${b[1]}</span>`;

          return `
          <div>
            <a href="${data.show_path}" class="font-weight-bolder text-secondary">
              ${data.name}
            </a>
          </div>
          <div>
            ${badge(source)}${badge(onR2)}${badge(serving)}
          </div>
            `;
        }
      },
      {
        field: 'description',
        title: 'Deskripsi',
        width: 200,
        sortable: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.description}</span>`;
        }
      },
      {
        field: 'file_name',
        title: 'Nama File Upload',
        width: 200,
        sortable: false,
        template: function(data) {
          return `
          <span class="font-weight-bolder">${data.filename}</span>
          `;
        }
      },
      {
        field: 'created_at',
        title: 'Tanggal Upload',
        width: 150,
        template: function(data) {
          return `
          <span class="font-weight-bolder">${data.created_at}</span>
          `;
        }
      },
      {
        field: 'Actions',
        title: 'Actions',
        sortable: false,
        width: 150,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.show_path}" title="Tampilkan">
              <i class="fa fa-eye text-primary"></i>
            </a>
            
            <a href="${data.delete_path}" data-method="delete" data-confirm="Apakah anda yakin ingin menghapus video ini?" class="btn btn-sm btn-clean btn-icon" title="Delete">
              <i class="la la-trash text-danger"></i>
            </a>
          `;
        },
      }
    ]
  }
}

// <a class="btn btn-sm btn-clean btn-icon" href="${data.preview_path}" title="Tampilkan">
//   <span class="far fa-play-circle text-primary"></span>
// </a>
//<a class="btn btn-sm btn-clean btn-icon" data-toggle="modal" data-target="#editVideo-${data.id}" title="Ubah"> 
//   <i class="fa fa-pencil-alt text-primary"></i>
//</a>